<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :dataset-id="datasetId" v-model="recordId"></record-select>
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('bibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('bibNumber')" v-model.lazy="bibNumber">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('name')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('name')" v-model.lazy="name">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('country')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country')" v-model.lazy="country">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('rank')" class="col-sm-4 col-form-label">Rank</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('rank')" v-model.lazy="rank">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('score')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('score')" v-model.lazy="score">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="fields">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternBibNumber')" class="col-sm-4 col-form-label">Bib number</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternBibNumber')" v-model.lazy="patternBibNumber">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternName')" class="col-sm-4 col-form-label">Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternName')" v-model.lazy="patternName">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternRank')" class="col-sm-4 col-form-label">Rank</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternRank')" v-model.lazy="patternRank">
        </div>
      </div>
      <div class="form-group row">
        <label :for="safeId('patternScore')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore')" v-model.lazy="patternScore">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapRecord, mapTemplateData } from '@/utils'

  export default {
    name: 'uiaa-victory-ceremony-athlete',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['title', 'bibNumber', 'rank', 'name', 'country', 'score']),
      ...mapTemplateData(['datasetId', 'recordId']),
      record () {
        const record = this.$store.getters.datasetRecord(this.datasetId, this.recordId)
        return mapRecord(record, this.patterns)
      },
      fields () {
        return this.$store.getters.datasetColumns(this.datasetId)
      },

      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        'patternBibNumber': {default: '${BIB}'},
        'patternRank': {default: '${RANK}'},
        'patternName': {default: '${LAST NAME} ${FIRST NAME}'},
        'patternCountry': {default: '${COUNTRY}'},
        'patternScore': {default: '${SCORE}${Route 1}'}
        /* eslint-enable no-template-curly-in-string */
      }),

      patterns () {
        return {
          'bibNumber': this.patternBibNumber,
          'rank': this.patternRank,
          'name': this.patternName,
          'country': this.patternCountry,
          'score': this.patternScore
        }
      }
    },
    watch: {
      record: function (record) {
        this.bibNumber = record.bibNumber
        this.name = record.name
        this.country = record.country
        this.rank = record.rank
        this.score = record.score
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-victory-ceremony-athlete.vue